import { UUID } from "crypto";

/**
 * WhatsApp query key factory
 */
export const whatsappKeys = {
  all: ["whatsapp"] as const,
  instances: () => [...whatsappKeys.all, "instances"] as const,
  instance: (id: string) => [...whatsappKeys.instances(), id] as const,
  chats: () => [...whatsappKeys.all, "chats"] as const,
  chatsList: (
    search?: string,
    includeArchived?: boolean,
    archivedOnly?: boolean,
  ) =>
    [
      ...whatsappKeys.chats(),
      "list",
      { search, includeArchived, archivedOnly },
    ] as const,
  chat: (chatId: UUID) => [...whatsappKeys.chats(), chatId] as const,
  messages: (chatId: UUID) =>
    [...whatsappKeys.all, "messages", chatId] as const,
  unreadChats: () => [...whatsappKeys.chats(), "unread"] as const,
} as const;
